import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ProjectImg from "../../assets/img/project.jpg";
import ProjectImg2 from "../../assets/img/project2.jpg";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { GREEN_PRIMRY } from "../../utils/const";
import useCustomState from "../../hooks/State";
import { convertNumbers } from "../../utils/ConvertNumbers";
import Counter from "./Counter";
import Call from "../../service/API";
import { useMountAPI } from "../../hooks/APICall";

const Details = (props) => {
  const projectId = props.data.match.params.pId;
  const userId = props.data.match.params.userId;
  const categoryId = props.data.match.params.categoryId;
  const image = projectId % 2 === 0 ? ProjectImg : ProjectImg2;

  const countersIsLoading = useCustomState(true);
  const userInfoIsLoading = useCustomState(true);
  const projectIsLoading = useCustomState(true);
  const categoryIsLoading = useCustomState(true);
  const thisUserCategoryCounters = useCustomState([]);
  const user = useCustomState({});
  const project = useCustomState({});
  const category = useCustomState({});

  const countersUtils = {
    page: 1,
    count: 10,
    userId: userId,
    projectId: projectId,
    isLoading: countersIsLoading,
    counters: thisUserCategoryCounters,
    categoryId: categoryId,
  };

  const userUtils = {
    isLoading: userInfoIsLoading,
    user: user,
    userId: userId,
  };

  const projectUtils = {
    isLoading: projectIsLoading,
    project: project,
    projectId: projectId,
  };

  const categoryUtils = {
    isLoading: categoryIsLoading,
    category: category,
    categoryId: categoryId,
  };

  useMountAPI(fetchCounters, countersUtils);
  useMountAPI(fetchUserInfo, userUtils);
  useMountAPI(fetchProjectInfo, projectUtils);
  useMountAPI(fetchCategoryInfo, categoryUtils);

  // useEffect(() => {
  //   if (!countersIsLoading.value) {
  //     user.handleChange(
  //       thisUserCategoryCounters.value[0].water_meter_user_info
  //     );
  //     project.handleChange(
  //       thisUserCategoryCounters.value[0].water_meter_project_info
  //     );
  //     category.handleChange(
  //       thisUserCategoryCounters.value[0].water_meter_tag_info
  //     );
  //   }
  // }, [countersIsLoading.value]);

  if (!countersIsLoading.value) {
    let username = "";
    if (user.value.user_name && user.value.user_lastname) {
      username = user.value.user_name + " " + user.value.user_lastname;
    } else {
      if (thisUserCategoryCounters.value.length > 0) {
        username =
          thisUserCategoryCounters.value[0].water_meter_user_info.user_name +
          " " +
          thisUserCategoryCounters.value[0].water_meter_user_info.user_lastname;
      } else {
        username = "<کاربر>";
      }
    }
    const categoryName = category.value.water_meter_tag_name;
    const projectName = project.value.water_meter_project_name;
    return (
      <div
        style={{
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "24px",
        }}
        s
      >
        <Grid container>
          <Grid align="center" item sx={12} sm={12} md={12} lg={12}>
            <div
              style={{
                // maxWidth: "820px",
                marginTop: "48px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                paddingBottom: "24px",
              }}
            >
              <img
                src={image}
                style={{
                  width: "160px",
                  height: "160px",
                  borderRadius: "50%",
                  marginTop: "-70px",
                }}
                alt="project"
              />
              <Typography style={{ fontSize: "24px" }}>
                <span>کنتورهای </span>
                <span style={{ color: GREEN_PRIMRY }}>
                  {categoryName + " "}
                </span>
                <span style={{ color: "#1976d2" }}>{username + " "}</span>
                <span>در </span>
                <span style={{ color: "#d32f2f" }}>
                  {convertNumbers(projectName)}
                </span>
              </Typography>
              <hr />
              <Grid
                container
                style={{ paddingRight: "16px", paddingLeft: "16px" }}
              >
                <Grid item sx={12} sm={12} md={12} lg={12}>
                  <Grid container>
                    {thisUserCategoryCounters.value.map((counter, idx) => {
                      return (
                        <Counter
                          data={counter}
                          key={idx}
                          index={idx}
                          projectId={projectId}
                          userId={userId}
                          categoryId={categoryId}
                        />
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return null;
  }
};

export default Details;

const fetchCounters = (utils) => {
  const page = 1;
  const count = 10;
  const userId = utils.userId;
  const projectId = utils.projectId;
  const isLoading = utils.isLoading;
  const counters = utils.counters;
  const categoryId = utils.categoryId;

  const data = {
    page: page,
    count: count,
    user_id: userId,
    project_id: projectId,
  };

  Call("POST", "watermeters/admin/getAll", data)
    .then((response) => {
      // console.log("this user counters: ", response);
      if (response.data.code == 200) {
        const thisUserCounters = response.data.data;
        const cs = thisUserCounters.filter(
          (c) => c.water_meter_tag_info.water_meter_tag_id == categoryId
        );
        counters.handleChange(cs);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const fetchUserInfo = (utils) => {
  const isLoading = utils.isLoading;
  const user = utils.user;
  const userId = utils.userId;

  const data = {
    other_user_id: userId,
    user_phone: null,
  };

  Call("POST", "users/admin/getOneUser", data)
    .then((response) => {
      // console.log("fetched user info: ", response);
      if (response.data.code == 200) {
        user.handleChange(response.data.data);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log("error fetched user data: ", data);
      }
      // console.log("error fetched user data: ", data);
      isLoading.handleChange(false);
    });
};

const fetchProjectInfo = (utils) => {
  const isLoading = utils.isLoading;
  const project = utils.project;
  const projectId = utils.projectId;

  const data = {
    water_meter_project_id: projectId,
  };

  Call("POST", "WaterMeterProjectsURL/admin/getOne", data)
    .then((response) => {
      // console.log("fetched project: ", response);
      if (response.data.code == 200) {
        project.handleChange(response.data.data.data);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const fetchCategoryInfo = (utils) => {
  const isLoading = utils.isLoading;
  const category = utils.category;
  const categoryId = utils.categoryId;

  const data = {
    page: 1,
    count: 10,
    water_meter_tag_name: "",
    water_meter_type_create_date: "",
  };

  Call("POST", "WaterMeterTags/admin/getAll", data)
    .then((response) => {
      // console.log("fetched category Info: ", response);
      if (response.data.code == 200) {
        const cat = response.data.data.filter(
          (c) => c.water_meter_tag_id == categoryId
        );
        if (cat.length == 0) {
          // console.log("Invalid categoryId!");
        } else {
          category.handleChange(cat[0]);
        }
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
